module.exports = __webpack_public_path__ + "img/scratches.4158965b.jpeg";